import { RootState } from '../store';

export const isLoading = (state: RootState) => state.navigation.loadingTaskCount > 0;

export const activePage = (state: RootState) => state.router.location.pathname.split('/')[1];